import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import NavigationBanner from "@components/V2/Banners/NavigationBanner"
const StoryblokNavigationBanner = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.NavigationBanner>) => {
  return (
    <NavigationBanner
      title={blok.title}
      description={blok.description}
      backgroundColor={blok.backgroundColor}
      superscript={blok.superscript}
      navigationItems={blok.navigationItems}
      mobileGridOrder={mobileGridOrder}
      id={blok.id}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokNavigationBanner
